import React, { Component } from "react";
import {
  Offcanvas,
  Row,
  Col,
  Form,
  Button,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import Calendar from "react-calendar";
import "./Workdesk.css";
import "react-calendar/dist/Calendar.css";
import { toast } from "react-toastify";

import LoadingOverlay from "./LoadingOverlay";
export default class Workdesk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      show1: false,
      data: [],
      tables: [],
      workdesk: [],
      leavetypes: [],
      raddendance: [],
      selectedrattItems: [],
      note: "",
      leave: [],
      errors: {},
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      filteredData: null,
      filteredDataOne: null,
      markAttendanceDate: new Date(),
      regularizeAttendanceDate: new Date(),
      attended: [],
      Holidays: [],
      employeelist: [],
      isSubmitting: false,
      isleaveSubmitting: false,
      isWorkdeskUpdating: false,
      isLeaveCancelUpdating: false,
      regularizeSubmittingStatus: "",
      originalToDate: "",
      disabledDates: this.loadDisabledDatesFromStorage() || [],
      isAllLeaveselected: false,
      isAllAttedanceselected: false,
      RequestedBy: "",
      LeaveBalance: "",
      FromDate: this.getCurrentDate(), // Set default value to current date
      ToDate: "",
      NoOfLeaves: "",
      LeaveType: "",
      remarks: "",
      RemarksRemarks: "",
      ApproverID: "",
      ApproverType: "",
      currentPage: 1,
      itemsPerPage: 10,
      Decision: "",
      DecisionRemarks: "",
      leaverequestapprovals_Id: "",
      reason: "",
      aId: "",
      aDate: "",
      employees_Id: "",
      Cancel: "",
      isEditing: false,
      isNewEntry: false,
      isEditingone: false,
      isEditingtwo: false,
    };
  }
  tableClms = () => [
    {
      name: (
        <>
          <input
            type="checkbox"
            checked={this.state.isAllLeaveselected}
            onChange={this.handleSelectAllCheckbox}
          />
          &nbsp;S.No
        </>
      ),
      selector: (row, index) => index + 1,
      cell: (row) => (
        <input
          type="checkbox"
          checked={this.state.selectedrattItems.includes(
            row.leaverequestapprovals_Id,
          )}
          onChange={() =>
            this.handleSingleCheckboxChange(row.leaverequestapprovals_Id)
          }
        />
      ),
    },
    {
      name: "Requester",
      selector: (row) => row.fName,
      cell: (row) => (
        <span>
          {row.fName} {row.lName}
        </span>
      ),
    },
    {
      name: "Type",
      selector: (row) => row.LeaveType,
      cell: (row) => <span>{row.LeaveType}</span>,
    },
    {
      name: "Days",
      selector: (row) => row.NoOfLeaves,
      cell: (row) => <span>{row.NoOfLeaves}</span>,
    },
    {
      name: "From Date",
      selector: (row) => row.FromDate,
      cell: (row) => <span>{window.formatDate(row.FromDate)}</span>,
    },
    {
      name: "To Date",
      selector: (row) => row.ToDate,
      cell: (row) => <span>{window.formatDate(row.ToDate)}</span>,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button
            onClick={() => this.handleEnterEditMode(row)}
            className="bi bi-pen btn btn-primary m-1"
          ></button>
        </div>
      ),
    },
  ];
  tableClmsOne = () => [
    {
      // name: "S.No",
      name: (
        <>
          <input
            type="checkbox"
            checked={this.state.isAllAttedanceselected}
            onChange={this.handleSelectAllattendanceCheckbox}
          />
          &nbsp;S.No
        </>
      ),
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row) => (
        <input
          type="checkbox"
          //id={`checkbox-${row.aId}`}
          checked={this.state.selectedrattItems.includes(row.aId)}
          onChange={() => this.handleSingleattendanceCheckboxChange(row.aId)}
        />
      ),
    },
    {
      name: "Requester",
      selector: (row) => row.fName,
      sortable: true,
      cell: (row) => (
        <span>
          {row.fName} {row.lName}
        </span>
      ),
    },
    {
      name: "Date",
      selector: (row) => row.aDate,
      sortable: true,
      cell: (row) => <span>{row.aDate}</span>,
    },
    {
      name: "Reason",
      selector: (row) => row.reason,
      sortable: true,
      cell: (row) => <span>{row.reason}</span>,
    },
    {
      name: "Actions",
      sortable: false,
      cell: (row, index) => (
        <div>
          <button
            onClick={() => this.handleEnterEditModeOne(row)}
            className="bi bi-pen btn btn-primary m-1"
          ></button>
        </div>
      ),
    },
  ];
  tableleavecancelationClms = () => [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      cell: (row, index) => <span>{index + 1}</span>,
    },
    {
      name: "Requester",
      selector: (row) => row.fName,
      cell: (row) => (
        <span>
          {row.fName} {row.lName}
        </span>
      ),
    },
    {
      name: "Type",
      selector: (row) => row.LeaveType,
      cell: (row) => <span>{row.LeaveType}</span>,
    },
    {
      name: "Days",
      selector: (row) => row.NoOfLeaves,
      cell: (row) => <span>{row.NoOfLeaves}</span>,
    },
    {
      name: "Cancel Dates",
      cell: (row) => {
        try {
          const dates = JSON.parse(row.cancellationDates || "[]");
          return (
            <span style={{ fontSize: "11px" }}>
              {dates.map((d) => window.formatDate(d)).join(", ")}
            </span>
          );
        } catch (e) {
          return <span>-</span>;
        }
      },
    },
    {
      name: "Reason",
      selector: (row) => row.cancellationReason,
      cell: (row) => (
        <span title={row.cancellationReason} style={{ fontSize: "11px" }}>
          {row.cancellationReason
            ? row.cancellationReason.length > 30
              ? row.cancellationReason.substring(0, 30) + "..."
              : row.cancellationReason
            : "-"}
        </span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button
            onClick={() => this.handleCancellationDecision(row, "Approved")}
            className="btn btn-success btn-sm m-1"
            disabled={this.state.isLeaveCancelUpdating}
            title="Approve cancellation"
          >
            <i className="bi bi-check"></i> Approve
          </button>
          <button
            onClick={() => this.handleCancellationDecision(row, "Rejected")}
            className="btn btn-danger btn-sm m-1"
            disabled={this.state.isLeaveCancelUpdating}
            title="Reject cancellation"
          >
            <i className="bi bi-x"></i> Reject
          </button>
        </div>
      ),
    },
  ];
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ isEditing: false });
  };
  handleOffattendancecanvasClose = () => {
    this.setState({ isEditingone: false });
  };
  handleOffcanvascancelClose = () => {
    this.setState({ isEditingtwo: false });
  };
  handleCloseTne = () => {
    this.setState({ isEditing: false });
  };
  handleCloseToone = () => {
    this.setState({ isEditingone: false });
  };
  handleClosecancelToone = () => {
    this.setState({ isEditingtwo: false });
  };
  handleShowTwo = () => {
    this.setState({ showOne: true });
  };
  handleReguralizeDateChange = (date) => {
    this.setState({ regularizeAttendanceDate: date });
  };

  handleNoteChange = (event) => {
    this.setState({ note: event.target.value });
  };
  //leave all checkbox event
  handleSingleCheckboxChange = (id) => {
    this.setState((prevState) => {
      const updated = prevState.selectedrattItems.includes(id)
        ? prevState.selectedrattItems.filter((item) => item !== id)
        : [...prevState.selectedrattItems, id];
      return {
        selectedrattItems: updated,
        isAllLeaveselected: updated.length === this.state.workdesk.length,
      };
    });
  };
  handleSelectAllCheckbox = () => {
    const newSelectAll = !this.state.isAllLeaveselected;
    // Only select pending leave requests (status=1), exclude cancellation requests (status=5)
    const selected = newSelectAll
      ? this.state.workdesk
          // eslint-disable-next-line
          .filter((item) => item.status == 1)
          .map((item) => item.leaverequestapprovals_Id)
      : [];
    this.setState({
      isAllLeaveselected: newSelectAll,
      selectedrattItems: selected,
    });
  };
  //attendnace all checkbox event
  handleSingleattendanceCheckboxChange = (id) => {
    this.setState((prevState) => {
      const updated = prevState.selectedrattItems.includes(id)
        ? prevState.selectedrattItems.filter((item) => item !== id)
        : [...prevState.selectedrattItems, id];
      return {
        selectedrattItems: updated,
        isAllAttedanceselected:
          updated.length === this.state.raddendance.length,
      };
    });
  };
  handleSelectAllattendanceCheckbox = () => {
    const newSelectAll = !this.state.isAllAttedanceselected;
    const selected = newSelectAll
      ? this.state.raddendance.map((item) => item.aId)
      : [];
    this.setState({
      isAllAttedanceselected: newSelectAll,
      selectedrattItems: selected,
    });
  };
  handlersCheckboxChange = (id) => {
    this.setState(
      (prevState) => {
        let updatedItems = prevState.selectedrattItems.includes(id)
          ? prevState.selectedrattItems.filter((item) => item !== id) // Remove item if already selected
          : [...prevState.selectedrattItems, id]; // Add item if not selected

        return { selectedrattItems: updatedItems };
      },
      () => {},
    );
  };
  handlerCheckboxChange = (id) => {
    this.setState(
      (prevState) => {
        let updatedItems = prevState.selectedrattItems.includes(id)
          ? prevState.selectedrattItems.filter((item) => item !== id) // Remove item if already selected
          : [...prevState.selectedrattItems, id]; // Add item if not selected

        return { selectedrattItems: updatedItems };
      },
      () => {},
    );
  };

  isDateDisabledOne = ({ date }) => {
    // Calculate the current month's starting date
    const currentDate = new Date();
    const currentMonthStartDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      // date.getFullYear(),
      // date.getMonth(),
      1,
    );
    const isPastMonthStartDate = date < currentMonthStartDate;

    // Check if the current date is a Saturday (day 6) or Sunday (day 0)
    const isWeekend = date.getDay() === 6 || date.getDay() === 0;

    // Check if the current date is included in the list of disabled dates
    const isDisabledDate = this.state.disabledDates.some((disabledDate) => {
      // Parse the stored date string back to Date object
      const storedDate = new Date(disabledDate);
      return (
        storedDate.getFullYear() === date.getFullYear() &&
        storedDate.getMonth() === date.getMonth() &&
        storedDate.getDate() === date.getDate()
      );
    });
    if (
      date < currentMonthStartDate ||
      date > currentDate ||
      date.getDay() === 0 ||
      date.getDay() === 6
    ) {
      return true;
    }
    // Disable the date if it's before the current month's starting date,
    // after the current date, or if it's a Saturday, Sunday, or a disabled date
    return (
      isPastMonthStartDate || date > new Date() || isWeekend || isDisabledDate
    );
  };
  tileClassNameOne = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are zero-based
    const day = date.getDate();
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
    // Find the holiday object for the current date
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    // Check if the current date is a holiday
    const isHoliday = holiday !== undefined;
    // Check if the current date is a Saturday
    const isSaturday = date.getDay() === 6; // Saturday is the 6th day of the week (zero-based)

    // Check if the current date is the last Saturday of the month
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    const isLastSaturday = isSaturday && day > lastDayOfMonth - 7;
    if (isHoliday) {
      return "holiday"; // Apply holiday class
    } else if (isLastSaturday) {
      return "last-saturday"; // Apply last-saturday class
    } else {
      return null; // No special class
    }
  };
  loadDisabledDatesFromStorage() {
    const disabledDates = JSON.parse(localStorage.getItem("disabledDates"));
    console.log("Loaded disabled dates:", disabledDates);
    return disabledDates;
  }
  saveDisabledDatesToStorage(disabledDates) {
    console.log("Saving disabled dates:", disabledDates);
    localStorage.setItem("disabledDates", JSON.stringify(disabledDates));
  }
  // handleSubmit = () => {
  //   console.log("Submitting...");
  //   console.log("Date:", this.state.regularizeAttendanceDate);
  //   console.log("Note:", this.state.note);

  //   // Calculate the date 60 days ago
  //   const past60Days = new Date();
  //   past60Days.setDate(past60Days.getDate() - 60);

  //   // Add the selected date to the list of disabled dates if it's within the past 60 days
  //   const updatedDisabledDates =
  //     this.state.regularizeAttendanceDate >= past60Days
  //       ? [
  //           ...this.state.disabledDates,
  //           this.state.regularizeAttendanceDate.toISOString(), // Store date as string for simplicity
  //         ]
  //       : [...this.state.disabledDates];

  //   // Save updated disabled dates to localStorage
  //   this.saveDisabledDatesToStorage(updatedDisabledDates);

  //   // Reset the form and close the modal
  //   this.setState({
  //     showOne: false,
  //     disabledDates: updatedDisabledDates,
  //     regularizeAttendanceDate: new Date(),
  //     note: "",
  //   });
  // };

  handleBulkRegulaise = (e, status) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("aIds", this.state.selectedrattItems.join(","));
    formData.append("aStatus", status);
    fetch(configData.api_url + "C_Employees/updateregulariseAttendanceBulk", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            selectedrattItems: [],
          });
          this.regralizefetchHandler();
          this.handleCloseToone();
        }
      });
  };
  handleBulkleaveRegulaise = (e, status) => {
    e.preventDefault();
    // Only send IDs of pending leave requests (status=1), never cancellation rows (status=5)
    const pendingLeaveIds = this.state.workdesk
      // eslint-disable-next-line
      .filter(
        (r) =>
          r.status == 1 &&
          this.state.selectedrattItems.includes(r.leaverequestapprovals_Id),
      )
      .map((r) => r.leaverequestapprovals_Id);
    if (pendingLeaveIds.length === 0) {
      this.showToast("No pending leave requests selected.", "error");
      return;
    }
    this.setState({ isleaveSubmitting: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("leaverequestapprovals_Ids", pendingLeaveIds.join(","));
    formData.append("aStatus", status);
    fetch(
      configData.api_url + "C_Leaverequestapprovals/updateleaveStatusBulk",
      {
        // Enter your IP address here

        method: "POST",
        //headers :{ 'Content-Type' : 'application/json'},
        mode: "cors",
        body: formData, // body data type must match "Content-Type" header
      },
    )
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            selectedrattItems: [],
          });
          this.workdeskfetchHandler();
          this.handleCloseTne();
        }
      });
  };
  handleSubmit = (e, status) => {
    e.preventDefault();
    if (this.state.regularizeSubmittingStatus) {
      return;
    }
    this.setState({ regularizeSubmittingStatus: status });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("aId", this.state.aId);
    formData.append("aStatus", status);
    formData.append("employees_Id", this.state.employees_Id);
    fetch(configData.api_url + "C_Employees/updateregulariseAttendance", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.handleOffattendancecanvasClose();
          this.handleCloseToone();
          this.regralizefetchHandler();
          this.setState({
            aId: "",
            aStatus: "",
            employees_Id: "",
            sId: "",
            regularizeSubmittingStatus: "",
          });
        } else {
          this.setState({ regularizeSubmittingStatus: "" });
        }
      })
      .catch((error) => {
        console.error("Error updating regularization:", error);
        this.showToast("Error updating regularization request.", "error");
        this.setState({ regularizeSubmittingStatus: "" });
      });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  //editing
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("workdeskstatus", this.state.workdeskstatus);
    formData.append(
      "leaverequestapprovals_Id",
      this.state.leaverequestapprovals_Id,
    );
    this.setState({
      // uName: row.uName,
      fName: row.fName,
      LeaveBalance: row.LeaveBalance,
      FromDate: row.FromDate,
      ToDate: row.ToDate,
      NoOfLeaves: row.NoOfLeaves,
      leaves: row.leaves,
      LeaveType: row.LeaveType,
      remarks: row.remarks,
      Decision: row.Decision,
      DecisionRemarks: row.DecisionRemarks,
      ApproverID: row.ApproverID,
      ApproverType: row.ApproverType,
      compensatoryDate: row.compensatoryDate,
      leaverequestapprovals_Id: row.leaverequestapprovals_Id,
      originalToDate: row.ToDate,
      isEditing: true,
    });
  };
  handleEnterDuplicateMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("workdeskstatus", this.state.workdeskstatus);
    formData.append(
      "leaverequestapprovals_Id",
      this.state.leaverequestapprovals_Id,
    );
    this.setState({
      // uName: row.uName,
      fName: row.fName,
      LeaveBalance: row.LeaveBalance,
      FromDate: row.FromDate,
      ToDate: row.ToDate,
      NoOfLeaves: row.NoOfLeaves,
      leaves: row.leaves,
      LeaveType: row.LeaveType,
      remarks: row.remarks,
      Decision: row.Decision,
      DecisionRemarks: row.DecisionRemarks,
      ApproverID: row.ApproverID,
      ApproverType: row.ApproverType,
      compensatoryDate: row.compensatoryDate,
      leaverequestapprovals_Id: row.leaverequestapprovals_Id,
      originalToDate: row.ToDate,
      isEditingtwo: true,
    });
  };
  //edit
  handleEnterEditModeOne = (row, date) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    this.regralizefetchHandler(date);
    this.setState({
      fName: row.fName,
      aDate: row.aDate,
      aStatus: row.aStatus,
      reason: row.reason,
      aId: row.aId,
      employees_Id: row.employees_Id,
      selectedDate: date,
      isEditingone: true,
    });
  };
  //leave calcel edit
  handleEnterleavecalcelationEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("workdeskstatus", this.state.workdeskstatus);
    formData.append(
      "leaverequestapprovals_Id",
      this.state.leaverequestapprovals_Id,
    );
    this.setState({
      // uName: row.uName,
      fName: row.fName,
      LeaveBalance: row.LeaveBalance,
      FromDate: row.FromDate,
      ToDate: row.ToDate,
      NoOfLeaves: row.NoOfLeaves,
      leaves: row.leaves,
      LeaveType: row.LeaveType,
      remarks: row.remarks,
      Decision: row.Decision,
      DecisionRemarks: row.DecisionRemarks,
      ApproverID: row.ApproverID,
      ApproverType: row.ApproverType,
      Cancel: row.Cancel,
      leaverequestapprovals_Id: row.leaverequestapprovals_Id,
      originalToDate: row.ToDate,
      isEditingtwo: true,
    });
  };
  // offcanvas Open
  handleShow = (workdesk) => {
    this.setState({ show: true, selectedTable: workdesk });
  };
  // Offcanvas close button
  handleClose = () => {
    this.setState({ show: false, selectedTable: null });
  };
  // offcanvas Open one
  handleShowOne = (workdesk) => {
    this.setState({ show1: true, selectedTable: workdesk });
  };
  // Offcanvas close button
  handleCloseOne = () => {
    this.setState({ show1: false, selectedTable: null });
  };

  getTables = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "/masters/gettables", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ tables: data.tables });
          //console.log(this.state.tables);
        }
      });
  };

  componentDidMount() {
    this.workdeskfetchHandler();
    this.leavetypesfetchHandler();
    this.leavetypesfetchUpdateHandler();
    this.leavetypesfetchUpdateStatus();
    this.AttendencefetchHandler();
    this.HolidayslistfetchHandler();
    this.regralizefetchHandler();
  }
  regralizefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/getregulariseAttendance", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ raddendance: data.list });
        }
      });
  };
  HolidayslistfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Holidayslist/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Holidays: data.list });
        }
      });
  };
  AttendencefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/getattendance", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list.attended });
        }
      });
  };
  leavetypesfetchUpdateStatus = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("DecisionRemarks", this.state.DecisionRemarks);
    formData.append(
      "leaverequestapprovals_Id",
      this.state.leaverequestapprovals_Id,
    );
    fetch(configData.api_url + "C_Leaverequestapprovals/updateleaveStatus", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ leavetypes: data.list });
        }
      });
  };
  leavetypesfetchUpdateHandler = () => {
    fetch(configData.api_url + "C_Leaverequestapprovals/updateworkdeskStatus", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ leavetypes: data.list });
        }
      });
  };
  leavetypesfetchHandler = () => {
    fetch(configData.api_url + "C_Leavetypes/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ leavetypes: data.list });
        }
      });
  };
  workdeskfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    //formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Leaverequestapprovals/getleaveslist", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({
            workdesk: data.list.sort(
              (a, b) =>
                Number(b.leaverequestapprovals_Id) -
                Number(a.leaverequestapprovals_Id),
            ),
          });
        }
      });
  };
  validateForm() {
    let data = this.state;
    let errors = {};
    let formIsValid = true;
    if (!data["Decision"]) {
      formIsValid = false;
      toast.info("*Please Enter Decision.");
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  WorkdeskupdateHandler = (e) => {
    e.preventDefault();
    if (this.state.isWorkdeskUpdating) {
      return;
    }
    //   setButtons(contacts);
    if (this.validateForm()) {
      this.setState({ isWorkdeskUpdating: true });
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("remarks", this.state.remarks);
      formData.append("FromDate", this.state.FromDate);
      formData.append("ToDate", this.state.ToDate);
      formData.append("Decision", this.state.Decision);
      formData.append("DecisionRemarks", this.state.DecisionRemarks);
      formData.append("compensatoryDate", this.state.compensatoryDate);
      formData.append(
        "leaverequestapprovals_Id",
        this.state.leaverequestapprovals_Id,
      );
      fetch(configData.api_url + "C_Leaverequestapprovals/updateleaveStatus", {
        // Enter your IP address here

        method: "POST",
        //headers :{ 'Content-Type' : 'application/json'},
        mode: "cors",
        body: formData, // body data type must match "Content-Type" header
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            this.workdeskfetchHandler();
            this.handleCloseTne();
            this.handleOffcanvasClose();
            this.setState({
              uName: "",
              LeaveBalance: "",
              FromDate: "",
              ToDate: "",
              NoOfLeaves: "",
              LeaveType: "",
              remarks: "",
              Decision: "",
              DecisionRemarks: "",
              ApproverID: "",
              ApproverType: "",
              leaverequestapprovals_Id: "",
              originalToDate: "",
              isWorkdeskUpdating: false,
            });
          } else {
            this.setState({ isWorkdeskUpdating: false });
          }
        })
        .catch((error) => {
          console.error("Error updating leave request:", error);
          this.showToast("Error updating leave request.", "error");
          this.setState({ isWorkdeskUpdating: false });
        });
    }
  };
  validatecancelForm() {
    let data = this.state;
    let errors = {};
    let formIsValid = true;
    if (!data["Cancel"]) {
      formIsValid = false;
      toast.info("*Please Enter Cancel.");
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  // Inline Approve/Reject for a cancellation row — bypasses the offcanvas entirely
  handleCancellationDecision = (row, decision) => {
    if (this.state.isLeaveCancelUpdating) return;
    let remarks = "";
    if (decision === "Rejected") {
      remarks = window.prompt("Enter rejection reason:");
      if (remarks === null) return; // user cancelled
      if (!remarks.trim()) {
        this.showToast("Rejection reason is required.", "error");
        return;
      }
    } else {
      if (
        !window.confirm(
          "Approve cancellation for " +
            row.fName +
            " " +
            row.lName +
            " — this will reverse their leave balance. Continue?",
        )
      )
        return;
      remarks = "Approved";
    }

    this.setState({ isLeaveCancelUpdating: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("leaverequestapprovals_Id", row.leaverequestapprovals_Id);
    formData.append("cancellationDecision", decision);
    formData.append("cancellationDecisionRemarks", remarks);

    fetch(
      configData.api_url + "C_Leaverequestapprovals/processLeaveCancellation",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      },
    )
      .then((r) => r.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        this.setState({ isLeaveCancelUpdating: false });
        if (data.status === "success") {
          this.workdeskfetchHandler();
        }
      })
      .catch((err) => {
        console.error("Cancellation decision error:", err);
        this.showToast("Error processing cancellation.", "error");
        this.setState({ isLeaveCancelUpdating: false });
      });
  };

  WorkdeskupdateleavecancelationHandler = (e) => {
    e.preventDefault();
    if (this.state.isLeaveCancelUpdating) {
      return;
    }
    //   setButtons(contacts);
    if (this.validatecancelForm()) {
      this.setState({ isLeaveCancelUpdating: true });
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append(
        "leaverequestapprovals_Id",
        this.state.leaverequestapprovals_Id,
      );
      // cancellationDecision must be "Approved" or "Rejected"
      formData.append("cancellationDecision", this.state.Decision);
      formData.append(
        "cancellationDecisionRemarks",
        this.state.DecisionRemarks,
      );
      fetch(
        configData.api_url + "C_Leaverequestapprovals/processLeaveCancellation",
        {
          // Enter your IP address here

          method: "POST",
          //headers :{ 'Content-Type' : 'application/json'},
          mode: "cors",
          body: formData, // body data type must match "Content-Type" header
        },
      )
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            this.workdeskfetchHandler();
            this.handleClosecancelToone();
            this.handleOffcanvascancelClose();
            this.setState({
              uName: "",
              LeaveBalance: "",
              FromDate: "",
              ToDate: "",
              NoOfLeaves: "",
              LeaveType: "",
              remarks: "",
              Decision: "",
              DecisionRemarks: "",
              ApproverID: "",
              ApproverType: "",
              leaverequestapprovals_Id: "",
              originalToDate: "",
              isLeaveCancelUpdating: false,
            });
          } else {
            this.setState({ isLeaveCancelUpdating: false });
          }
        })
        .catch((error) => {
          console.error("Error updating leave cancellation:", error);
          this.showToast("Error updating leave cancellation request.", "error");
          this.setState({ isLeaveCancelUpdating: false });
        });
    }
  };
  // Handler method for Approved button
  handleApprove = () => {
    // Additional logic if needed before making the API call
    this.updateWorkdesk("approved");
  };

  // Handler method for Rejected button
  handleReject = () => {
    // Additional logic if needed before making the API call
    this.updateWorkdesk("rejected");
  };

  handleRequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ RequestedBy: fieldValue });
  };
  handleLeaveBalanceChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ LeaveBalance: fieldValue });
  };
  getCurrentDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();

    // Add leading zeros if month or day is less than 10
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;

    return `${year}-${month}-${day}`;
  }
  handleFromDateChange = (e) => {
    const fromDate = e.target.value;
    this.setState({ FromDate: fromDate }, () => {
      this.calculateLeaveBalance();
    });
  };
  handleToDateChange = (e) => {
    const toDate = e.target.value;
    this.setState({ ToDate: toDate }, () => {
      this.calculateLeaveBalance();
    });
  };

  calculateLeaveBalance = () => {
    const { FromDate, ToDate } = this.state;

    if (!FromDate || !ToDate) {
      return;
    }

    const fromDateTime = new Date(`${FromDate}T00:00:00`).getTime();
    const toDateTime = new Date(`${ToDate}T00:00:00`).getTime();
    const differenceInDays = Math.floor(
      (toDateTime - fromDateTime) / (1000 * 3600 * 24),
    );

    this.setState({
      NoOfLeaves: differenceInDays >= 0 ? differenceInDays + 1 : 0,
    });
  };
  handleNoOfLeavesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ NoOfLeaves: fieldValue });
  };
  handleLeaveTypeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ LeaveType: fieldValue });
  };
  handleDecisionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ remarks: fieldValue });
  };
  handleDecisionCancelChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ Cancel: fieldValue });
  };
  handleDecisionChanges = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ Decision: fieldValue });
  };
  handleDecisionRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ DecisionRemarks: fieldValue });
  };
  handleApproverIDChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ApproverID: fieldValue });
  };
  handleApproverTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ApproverType: fieldValue });
  };
  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    // Only search within pending leave requests (status=1), not cancellation requests
    const filteredData = this.state.workdesk
      // eslint-disable-next-line
      .filter((row) => row.status == 1)
      .filter((row) => {
        return Object.values(row).join(" ").toLowerCase().includes(searchValue);
      });
    this.setState({ filteredData });
  };
  handleFilterOne = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredDataOne = this.state.raddendance.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredDataOne });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };
  handlePageChangeone = (page) => {
    this.setState({ currentPage: page });
  };
  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };
  handlePerRowsChangeone = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };
  handleDateChange = (date) => {
    console.log("Selected Date:", date);
    // Update state to reflect the selected date
    this.setState({ markAttendanceDate: date });
  };
  tileDisabled = ({ date, view }) => {
    // Disable past dates in month view
    if (view === "month" && date < new Date()) {
      return true;
    }
    // Disable future dates in month view
    if (view === "month" && date > new Date()) {
      return true;
    }
    // Disable specific dates in year view if needed
    // Example: Disable dates before 2023
    // if (view === "year" && date.getFullYear() < 2023) {
    //   return true;
    // }
    return false;
  };
  render() {
    // const uName = sessionStorage.getItem("userName");
    const { selectedTable } = this.state;
    // Split workdesk items: status=1 → pending leaves, status=5 → pending cancellations
    // eslint-disable-next-line
    const pendingLeaves = this.state.workdesk.filter((r) => r.status == 1);
    // eslint-disable-next-line
    const pendingCancellations = this.state.workdesk.filter(
      (r) => r.status == 5,
    );

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : pendingLeaves.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    const paginatedCancellations = pendingCancellations.slice(
      (this.state.currentPage - 1) * this.state.itemsPerPage,
      this.state.currentPage * this.state.itemsPerPage,
    );

    const paginatedDataone = this.state.filteredDataOne
      ? this.state.filteredDataOne.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.raddendance.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );
    // const minDate = new Date();
    // minDate.setDate(minDate.getDate() - 10);

    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="container">
          {/* <div className="row">
            <div className="col">
              <h3 className="logoskybluecolor">Workdesk</h3>
            </div>
          </div> */}

          <div className="row mt-1">
            <div className="col">
              <div>
                <Offcanvas
                  show={this.state.show}
                  onHide={this.handleClose}
                  {...this.props}
                  style={{ width: "500px", height: "auto" }}
                  placement="end"
                  backdrop="true"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                      Edit pages{selectedTable ? "Table" : ""}
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <div className="container">
                      <div className="row">
                        <div className="col">
                          {selectedTable && (
                            <pre>{JSON.stringify(selectedTable, null, 2)}</pre>
                          )}
                        </div>
                      </div>
                    </div>
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
              <div>
                {this.state.isEditing && (
                  // Edit Offcanvas
                  <Offcanvas
                    show={this.state.isEditing}
                    onHide={() => this.setState({ isEditing: false })}
                    {...this.props}
                    style={{ width: "500px", height: "auto" }}
                    placement="end"
                    backdrop="true"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Edit Leave Request</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <div className="form-horizontal form-label-left input_mask">
                        <Form className="form-horizontal form-label-left input_mask">
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Requested By
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                type="text"
                                onChange={this.handleRequestedByChange}
                                className="form-control"
                                name="fName"
                                //defaultValue={uName}
                                value={this.state.fName}
                                required="required"
                                placeholder="Enter RequestedBy"
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Prev. Leave Balance
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                type="text"
                                disabled
                                onChange={this.handleLeaveBalanceChange}
                                className="form-control"
                                name="leaves"
                                value={this.state.leaves}
                                required="required"
                                placeholder="Enter LeaveBalance"
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                From Date
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                type="date"
                                disabled
                                onChange={this.handleFromDateChange}
                                className="form-control"
                                name="FromDate"
                                min={this.getCurrentDate()}
                                value={this.state.FromDate}
                                required="required"
                                placeholder="Enter FromDate"
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                To Date
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                type="date"
                                disabled
                                onChange={this.handleToDateChange}
                                className="form-control"
                                name="ToDate"
                                value={this.state.ToDate}
                                required="required"
                                placeholder="Enter ToDate"
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                No. of Leaves
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                type="number"
                                disabled
                                onChange={this.handleNoOfLeavesChange}
                                className="form-control"
                                name="NoOfLeaves"
                                value={this.state.NoOfLeaves}
                                required="required"
                                placeholder="Enter NoOfLeaves"
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Leave Type
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <select
                                className="form-select"
                                name="LeaveType"
                                value={this.state.LeaveType}
                                disabled
                                onChange={this.handleLeaveTypeChange}
                              >
                                <option defaultValue> Select Leave Type</option>
                                {this.state.leavetypes.map(
                                  (api, index, idx) => (
                                    <option key={index} value={api.LeaveType}>
                                      {api.LeaveType}
                                    </option>
                                  ),
                                )}
                              </select>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Remarks
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                disabled
                                as="textarea"
                                onChange={this.handleDecisionChange}
                                className="form-control"
                                name="remarks"
                                value={this.state.remarks}
                                required="required"
                                placeholder="Enter Remarks"
                                rows={3}
                              />
                            </Col>
                          </Row>
                          {this.state.LeaveType === "Compensatory Leave" && (
                            <Row className="mb-3">
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Compensatory Date
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="date"
                                  disabled
                                  className="form-control"
                                  name="compensatoryDate"
                                  value={this.state.compensatoryDate || ""}
                                  placeholder="Enter Compensatory Date"
                                />
                              </Col>
                            </Row>
                          )}
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Decision
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <select
                                className="form-select"
                                name="Decision"
                                value={this.state.Decision}
                                onChange={this.handleDecisionChanges}
                              >
                                <option>Select</option>
                                <option value="Approved">Approved</option>
                                <option value="Rejected">Rejected</option>
                              </select>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Decision Remarks
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                as="textarea"
                                onChange={this.handleDecisionRemarksChange}
                                className="form-control"
                                name="DecisionRemarks"
                                value={this.state.DecisionRemarks}
                                required="required"
                                placeholder="Enter DecisionRemarks"
                                rows={3}
                              />
                            </Col>
                          </Row>
                          <div style={{ float: "right" }}>
                            <Button
                              className="btn btn-success me-2 mt-3 mb-5"
                              variant="success"
                              onClick={this.WorkdeskupdateHandler}
                              disabled={this.state.isWorkdeskUpdating}
                            >
                              {this.state.isWorkdeskUpdating
                                ? "Updating..."
                                : "Update"}
                            </Button>
                          </div>
                        </Form>
                      </div>
                    </Offcanvas.Body>
                  </Offcanvas>
                )}
              </div>

              <div>
                {this.state.isEditingone && (
                  // Edit Offcanvas
                  <Offcanvas
                    show={this.state.isEditingone}
                    onHide={() => this.setState({ isEditingone: false })}
                    {...this.props}
                    style={{ width: "500px", height: "auto" }}
                    placement="end"
                    backdrop="true"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>
                        Edit Attendance Regularization Requests
                      </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <div className="form-horizontal form-label-left input_mask">
                        <Form className="form-horizontal form-label-left input_mask">
                          <div className="container">
                            <div className="row">
                              <div className="col mt-5">
                                <div>
                                  <Calendar
                                    onChange={this.handleReguralizeDateChange}
                                    value={this.state.aDate}
                                    maxDate={new Date()}
                                    // minDate={past60Days}
                                    defaultValue={this.state.date}
                                    //tileDisabled={this.isDateDisabledOne}
                                    tileClassNameOne={this.tileClassNameOne}
                                    tileContent={({ date, view }) => {
                                      // Display holiday purpose on hover for month view
                                      if (view === "month") {
                                        const year = date.getFullYear();
                                        const month = date.getMonth() + 1; // Months are zero-based
                                        const day = date.getDate();
                                        const dateString = `${year}-${
                                          month < 10 ? "0" + month : month
                                        }-${day < 10 ? "0" + day : day}`;
                                        const holiday =
                                          this.state.Holidays.find(
                                            (holiday) =>
                                              holiday.Date === dateString,
                                          );

                                        if (holiday) {
                                          return (
                                            <OverlayTrigger
                                              overlay={
                                                <Tooltip id="tooltip">
                                                  {holiday.Festival}
                                                </Tooltip>
                                              }
                                            >
                                              <span className="d-inline-block holiday-tooltip">
                                                {day}
                                              </span>
                                            </OverlayTrigger>
                                          );
                                        } else {
                                          return (
                                            <span className="d-inline-block">
                                              {day}
                                            </span>
                                          );
                                        }
                                      }
                                    }}
                                  />
                                  <Form.Group className="form-group">
                                    <Form.Label className="control-label">
                                      Please Enter Regularize note
                                    </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="reason"
                                      value={this.state.reason}
                                      rows={5}
                                    />
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="mt-5">
                                <Button
                                  variant="danger"
                                  type="submit"
                                  style={{
                                    marginRight: "5px",
                                    marginTop: "20px",
                                  }}
                                  onClick={(e) => this.handleSubmit(e, "3")}
                                  disabled={
                                    this.state.regularizeSubmittingStatus ===
                                    "3"
                                  }
                                >
                                  {this.state.regularizeSubmittingStatus === "3"
                                    ? "Rejecting..."
                                    : "Reject"}
                                </Button>
                                &nbsp;
                                <Button
                                  variant="success"
                                  type="submit"
                                  style={{ float: "right" }}
                                  onClick={(e) => this.handleSubmit(e, "4")}
                                  disabled={
                                    this.state.regularizeSubmittingStatus ===
                                    "4"
                                  }
                                >
                                  {this.state.regularizeSubmittingStatus === "4"
                                    ? "Approving..."
                                    : "Approve"}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Offcanvas.Body>
                  </Offcanvas>
                )}
              </div>

              <div className="mb-3">
                <div>
                  <h3 className="logoskybluecolor">Leave Request</h3>
                  {/* searchbar,pagination,filter */}
                  <input
                    style={{ float: "left", marginBottom: "10px" }}
                    type="text"
                    onChange={this.handleFilter}
                    placeholder="Search..."
                  />
                  &nbsp;
                  <button
                    style={{
                      float: "right",
                      marginLeft: "10px",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    variant="primary"
                    disabled={this.state.isleaveSubmitting}
                    onClick={(e) =>
                      this.handleBulkleaveRegulaise(e, "Approved")
                    }
                    className="bi bi-check btn btn-success"
                  >
                    Approve
                  </button>{" "}
                  &nbsp;
                  <button
                    variant="danger"
                    style={{
                      float: "right",
                      background: "#dc3545",
                      marginLeft: "10px",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    disabled={this.state.isleaveSubmitting}
                    onClick={(e) =>
                      this.handleBulkleaveRegulaise(e, "Rejected")
                    }
                    className="bi bi-x btn btn-success btn-danger"
                  >
                    {" "}
                    Reject{" "}
                  </button>
                  <DataTable
                    data={paginatedData}
                    columns={this.tableClms()}
                    pagination
                    paginationServer
                    paginationTotalRows={
                      this.state.filteredData
                        ? this.state.filteredData.length
                        : pendingLeaves.length
                    }
                    // paginationTotalRows={this.state.insurance.length}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    paginationRowsPerPageOptions={[
                      100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                    ]}
                    paginationPerPage={100}
                    keyField="leaverequestapprovals_Id"
                    className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                  />
                </div>
              </div>

              {/* Leave Cancellation Requests — shows only status=5 rows */}
              <div className="mb-3">
                <div>
                  <h3 className="logoskybluecolor">
                    Leave Cancellation Requests
                    {pendingCancellations.length > 0 && (
                      <span
                        style={{
                          marginLeft: "10px",
                          fontSize: "14px",
                          background: "#fd7e14",
                          color: "#fff",
                          padding: "2px 10px",
                          borderRadius: "12px",
                        }}
                      >
                        {pendingCancellations.length} pending
                      </span>
                    )}
                  </h3>
                  {pendingCancellations.length === 0 ? (
                    <p style={{ color: "#6c757d", fontStyle: "italic" }}>
                      No pending cancellation requests.
                    </p>
                  ) : (
                    <DataTable
                      data={paginatedCancellations}
                      columns={this.tableleavecancelationClms()}
                      pagination
                      paginationTotalRows={pendingCancellations.length}
                      paginationRowsPerPageOptions={[
                        100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                      ]}
                      paginationPerPage={100}
                      keyField="leaverequestapprovals_Id"
                      className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                    />
                  )}
                </div>
              </div>

              <div className="mb-3">
                <div>
                  <h3 className="logoskybluecolor">
                    Attendance Regularization Requests
                  </h3>
                  {/* searchbar,pagination,filter */}
                  <input
                    style={{ float: "left", marginBottom: "10px" }}
                    type="text"
                    onChange={this.handleFilterOne}
                    placeholder="Search..."
                  />
                  <button
                    style={{
                      float: "right",
                      marginLeft: "10px",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    variant="primary"
                    onClick={(e) => this.handleBulkRegulaise(e, "Approved")}
                    className="bi bi-check btn btn-success"
                    disabled={this.state.isSubmitting}
                  >
                    Approve
                  </button>{" "}
                  &nbsp;
                  <button
                    variant="danger"
                    style={{
                      float: "right",
                      background: "#dc3545",
                      marginLeft: "10px",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    disabled={this.state.isSubmitting}
                    onClick={(e) => this.handleBulkRegulaise(e, "Rejected")}
                    className="bi bi-x btn btn-success btn-danger"
                  >
                    {" "}
                    Reject{" "}
                  </button>
                  <DataTable
                    data={paginatedDataone}
                    columns={this.tableClmsOne()}
                    pagination
                    paginationServer
                    paginationTotalRows={
                      this.state.filteredDataOne
                        ? this.state.filteredDataOne.length
                        : this.state.raddendance.length
                    }
                    // paginationTotalRows={this.state.insurance.length}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChangeone}
                    paginationRowsPerPageOptions={[
                      100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                    ]}
                    paginationPerPage={100}
                    keyField="leaverequestapprovals_Id"
                    className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
